/**
 * Normalize access groups from API array format to boolean object format.
 * Input:  ["resourcesManage", "resourceView", ...]
 * Output: { resourcesManage: true, resourceView: true, ... }
 *
 * Matches the shape used by orgPage.js SSR format ({ permissionName: true }).
 */
export const normalizeAccessGroups = arr =>
	Object.fromEntries((arr || []).map(g => [g, true]));
